import { isString, defaultsDeep } from "lodash";
import fetch from "fetch-retry";

// Following the following convention for creating new error classes:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#ES6_Custom_Error_Class

export class APIError extends Error {
	constructor(response, ...args) {
		super(...args);

		this.name = "APIError";
		this.response = response;

		console.error(this.response);

		window.vm.$log(
			`Http: error making request ${response.url} code ${response.status} ${response.statusText}`
		);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, APIError);
		}
	}
}

export class APIAuthError extends APIError {
	constructor(response, ...args) {
		super(response, ...args);
		this.name = "APIAuthError";

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, APIAuthError);
		}
	}
}

// Wrap fetch with application specific functionality.
// Currently all this wrapper does is provide a bit of ergonomics and translate
// otherwise "successful" non-200 requests into the approprate exception for
// capturing downstream in the VueJS context for displaying of errors in the UI.
const $http = {
	initDefaults: {
		credentials: "include",
		headers: {
			"content-type": "application/json",
		},
	},

	async get(resource, init = {}) {
		defaultsDeep(init, { method: "get" }, this.initDefaults);
		return this.call(resource, init);
	},

	async delete(resource, init = {}) {
		defaultsDeep(init, { method: "delete" }, this.initDefaults);
		return this.call(resource, init);
	},

	async post(resource, init = {}) {
		defaultsDeep(init, { method: "post" }, this.initDefaults);

		if (init.body && !isString(init.body)) {
			init.body = JSON.stringify(init.body);
		}

		return this.call(resource, init);
	},

	async call(resource, init) {
		let response = await fetch(resource, init);

		if (response.ok) {
			if (response.status === 204) return null;

			const contentType = response.headers.get("content-type");
			const isJSON =
				contentType && contentType.indexOf("application/json") !== -1;
			return isJSON ? response.json() : response.text();
		}

		switch (response.status) {
			case 401:
			case 403:
				throw new APIAuthError(
					response,
					"You are not authorized to access this resource"
				);
			case 409:
				return response;
			default:
				throw new APIError(response, "Error making request");
		}
	},
};

export default $http;
